var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("deputyAuth.form.title")))]),
      _c("delegation-substitutes-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "deputy-auth-form",
                { on: { saved: _vm.load } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(_vm._s(_vm.$t("deputyAuth.newDeputyAuth")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.deputyAuthItems,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.absent_user_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.substitute_user_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.from_date == null
                            ? _vm.$t("global.noSetTime")
                            : props.item.from_date
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.to_date == null
                            ? _vm.$t("global.noSetTime")
                            : props.item.to_date
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("span", _vm._g({}, on), [
                                      _vm._v(_vm._s(props.item.item_name))
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(props.item.item_description) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.comment))
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center px-0" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.$store.getters[
                                                "Ajax/loading"
                                              ],
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.remove(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }